import { useMediaQuery } from '@space-core/hooks'
import { ScreenSizes } from '@space-core/styles'

import clsx from 'clsx'
import styled from 'styled-components'

import type { DotsProps } from './types'

const DotsContainer = styled.div<{ $isMobile: boolean }>`
  ${(props) => (props.$isMobile ? `display: flex` : `display: none`)};
  z-index: 5;
  width: 100%;
  height: 1.5rem;
  bottom: 1rem;
`

const Dot = styled.div<{ $active: boolean }>`
  height: 0.25rem;
  margin: 0 0.188rem;

  ${({ $active }) =>
    `
    width: ${$active ? '1.5rem' : '0.5rem'};
    opacity: ${$active ? '1' : '0.3'};
    -webkit-transition-delay: ${$active ? '0.5s, 0.5s, 0s' : '0s'};
    transition-delay: ${$active ? '0.5s, 0.5s, 0s' : '0s'};
  `}

  -webkit-border-radius: 1.25rem;
  border-radius: 1.25rem;
  -webkit-transition: opacity 0.5s, background-color 0.5s, width 0.5s;
  transition: opacity 0.5s, background-color 0.5s, width 0.5s;
`

const Dots = ({ slides, activeSlide, onClickIndicators, className }: DotsProps) => {
  const isMobile = useMediaQuery(`(max-width: ${ScreenSizes.lg})`)

  return (
    <DotsContainer
      className={clsx('_position-absolute _justify-content-center _align-items-center', className)}
      data-test='dots-container'
      $isMobile={isMobile}>
      {slides.map((_, index) => (
        <Dot
          key={index}
          aria-hidden='true'
          data-test={`dot-${index}`}
          className='_d-inline-block _bg-gray-800 _cursor-pointer'
          $active={activeSlide === index}
          onClick={() => onClickIndicators(index)}
        />
      ))}
    </DotsContainer>
  )
}

export default Dots
